var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spread = this && this.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }

  return ar;
};
/* eslint-disable */


import * as XLSX from 'xlsx';
import { getDropdownOptionsForSku } from '../utils/PricingGridLayoutUtils';
import { find, get } from 'lodash';

var renameExcelHeaders = function renameExcelHeaders(ws, rowIndex, headers) {
  var range = XLSX.utils.decode_range(ws['!ref']);

  var _loop_1 = function _loop_1(C) {
    var address = XLSX.utils.encode_col(C) + rowIndex;
    if (!ws[address]) return "continue";
    var value = ws[address].v;
    var actualValue = headers.find(function (data) {
      return data.value.toString() === value.toString();
    });

    if (actualValue) {
      var headerName = actualValue.name;

      if (typeof headerName === 'string') {
        headerName = headerName.toUpperCase();
      }

      ws[address].v = headerName;
    }
  };

  for (var C = range.s.c; C <= range.e.c; ++C) {
    _loop_1(C);
  }

  return ws;
};

var getLastRow = function getLastRow(ws) {
  var range = ws['!ref'].split(':')[1];
  return range ? XLSX.utils.decode_cell(range).r : -1;
};

var arrayOfArraysExcel = function arrayOfArraysExcel(inputArray) {
  var arrayOfArrays = [];

  if (inputArray) {
    Object.keys(inputArray).forEach(function (attributeKey) {
      var subArray = [attributeKey];
      subArray.push(inputArray[attributeKey]);
      arrayOfArrays.push(subArray);
    });
  }

  return arrayOfArrays;
};

var addSelectedData = function addSelectedData(ws, selectedData) {
  var sku = selectedData.sku,
      displayedAttributes = selectedData.displayedAttributes,
      pivotAttributes = selectedData.pivotAttributes;

  if (pivotAttributes.Column !== 'None') {
    var pivotAttributesArray = [['PIVOT ATTRIBUTES SELECTION : ']];
    pivotAttributesArray = pivotAttributesArray.concat(arrayOfArraysExcel(pivotAttributes));
    ws = XLSX.utils.sheet_add_aoa(ws, pivotAttributesArray, {
      origin: getLastRow(ws) + 2
    });
  }

  var attributesArray = [['SELECTED ATTRIBUTE VALUES : '], ['ATTRIBUTE', 'VALUE'], ['Sku', sku]];
  attributesArray = attributesArray.concat(arrayOfArraysExcel(displayedAttributes));
  ws = XLSX.utils.sheet_add_aoa(ws, attributesArray, {
    origin: getLastRow(ws) + 2
  });
  return ws;
};

var addShippingConfiguration = function addShippingConfiguration(ws, shippingConfiguration) {
  var shippingConfig = [['SHIPPING CONFIGURATION: ']];
  Object.keys(shippingConfiguration).forEach(function (key, index) {
    var value = shippingConfiguration[key];

    if (key === 'fulfillmentLocation') {
      value = value.label;
    }

    shippingConfig[index + 1] = [key, value];
  });
  ws = XLSX.utils.sheet_add_aoa(ws, shippingConfig, {
    origin: getLastRow(ws) + 2
  });
  return ws;
};

var mergeColumnsExcel = function mergeColumnsExcel(headerList, startIndex, row, mergerArray) {
  var isNotBottomLevel = headerList.find(function (obj) {
    return obj.isParent;
  });

  if (isNotBottomLevel) {
    var numberofItems = headerList.length;
    var childrenHeaders = [];

    for (var i = 1; i <= numberofItems; i++) {
      var fromIndex = startIndex;
      var toIndex = fromIndex + (headerList[i - 1].count - 1);
      var addressTo = {
        c: toIndex,
        r: row
      };
      var addressFrom = {
        c: fromIndex,
        r: row
      };
      var range = XLSX.utils.encode_cell(addressFrom) + ":" + XLSX.utils.encode_cell(addressTo);
      startIndex = toIndex + 1;
      childrenHeaders.push.apply(childrenHeaders, __spread(headerList[i - 1].children));
      mergerArray.push(XLSX.utils.decode_range(range));
    }

    return mergeColumnsExcel(childrenHeaders, startIndex, row + 1, mergerArray);
  }

  return mergerArray;
};

var downloadExcel = function downloadExcel(ws, sku) {
  var wb = XLSX.utils.book_new();
  var fileName = sku ? sku + "-PricingInfo.xlsx" : 'Pricing-Info.xlsx';
  XLSX.utils.book_append_sheet(wb, ws, 'pricing-grid');
  XLSX.writeFile(wb, fileName, {
    cellStyles: true
  });
};

var getExcelRowData = function getExcelRowData(headers, rowData, includeShipping) {
  var headersMap = {};
  headers.forEach(function (head) {
    headersMap[head.value] = 1;
  });
  return rowData.map(function (row) {
    var currentRow = row;
    var filteredRow = {};
    Object.keys(row).forEach(function (key) {
      if (headersMap[key] === 1) {
        if (typeof row[key] === 'object') {
          var productPrice = row[key].productPrice;
          var shippingPrice = row[key].shippingPrice;
          var displayPrice = '-';
          var displayShippingPrice = '-';

          if (productPrice && productPrice.displayPrice) {
            var price = productPrice.displayPrice,
                currency = productPrice.currency;
            displayPrice = currency ? price.toLocaleString(undefined, {
              style: 'currency',
              currency: currency
            }) : price;

            if (shippingPrice && shippingPrice.displayShippingPrice !== undefined) {
              var shipPrice = shippingPrice.displayShippingPrice,
                  currency_1 = shippingPrice.currency;
              displayShippingPrice = currency_1 ? shipPrice.toLocaleString(undefined, {
                style: 'currency',
                currency: currency_1
              }) : shipPrice;
            }
          }

          if (includeShipping) {
            var productPriceKey = key + "Product Price";
            currentRow[productPriceKey] = displayPrice;
            filteredRow[productPriceKey] = currentRow[productPriceKey];
            var shippingPriceKey = key + "Shipping Price";
            currentRow[shippingPriceKey] = displayShippingPrice;
            filteredRow[shippingPriceKey] = currentRow[shippingPriceKey];
          } else {
            currentRow[key] = displayPrice;
            filteredRow[key] = currentRow[key];
          }
        } else {
          filteredRow[key] = currentRow[key];
        }
      }
    });
    return filteredRow;
  });
};

export var exportExcel = function exportExcel(rowData, headers, selectedRow, selectedColumns, skuData, logger, showCompetitivePricing, shippingConfiguration, isTabbedView) {
  var sku = Object.keys(skuData)[0];
  var data = skuData[sku];
  var displayedAttributes = skuData[sku].displayedAttributes;
  var pivotAttributes = {
    Row: data.selectedRow ? data.selectedRow.key : 'None',
    Column: data.selectedColumn ? data.selectedColumn.key : 'None'
  };
  var filteredDisplayedAttributes = displayedAttributes.filter(function (attribute) {
    return attribute != pivotAttributes.Row && attribute !== pivotAttributes.Column;
  });
  var displayedAttributesValues = getSelectedValues(skuData[sku], filteredDisplayedAttributes);
  var selectedData = {
    sku: sku,
    displayedAttributes: displayedAttributesValues,
    pivotAttributes: pivotAttributes
  };
  var subHeaders = [];
  var pinned = headers.pinned,
      headerList = headers.headerList;
  subHeaders.push(pinned);
  var isShipping = isShippingConfigurationSet(shippingConfiguration) && !showCompetitivePricing;
  var sortedHeaderList = [];
  ['Catalog Price', 'Contracts', 'Manufacturing Cost', 'Network'].forEach(function (headerName) {
    var obj = headerList.find(function (obj) {
      return obj.name === headerName;
    });

    if (obj) {
      sortedHeaderList.push(obj);
    }
  });
  return exportExcelData(sortedHeaderList, 0, selectedData, subHeaders, rowData, logger, showCompetitivePricing, isShipping, shippingConfiguration, isTabbedView);
};

var getMaxLength = function getMaxLength(data, count) {
  data.forEach(function (obj) {
    if (obj.isParent) {
      count += obj.children.length;
      getMaxLength(obj.children, count);
    } else {
      count++;
    }
  });
  return count;
};

var getColumnLength = function getColumnLength(data, count) {
  data.forEach(function (obj) {
    if (obj.isParent) {
      count = getColumnLength(obj.children, count);
    } else {
      count++;
    }
  });
  return count;
};

var createWorksheetObject = function createWorksheetObject(headerList, rowCount, ws, selectedData, isRowSelected, showCompetitivePricing, isShipping, isTabbedView) {
  var multiplicationFactor = isShipping ? 2 : 1;
  var isNotBottomLevel = headerList.find(function (obj) {
    return obj.isParent;
  });

  if (isNotBottomLevel) {
    var childrenHeaders_1 = [];
    var index_1 = 0;
    var topHeader_1 = {};
    var priceTypeHeader_1 = {};
    var startIndexCost_1 = 0;
    var startIndexPrice_1 = 0;

    if (isRowSelected) {
      topHeader_1[index_1++] = '';
      priceTypeHeader_1[index_1 - 1] = '';
    }

    headerList.forEach(function (data, i) {
      topHeader_1[index_1] = data.name.toUpperCase();

      if (['manufacturing cost', 'network'].includes(data.name.toLowerCase())) {
        if (priceTypeHeader_1[startIndexCost_1] !== 'COST') {
          priceTypeHeader_1[index_1] = 'COST';
          startIndexCost_1 = index_1;
        } else {
          priceTypeHeader_1[index_1] = '';
        }
      } else {
        if (priceTypeHeader_1[startIndexPrice_1] !== 'PRICE') {
          priceTypeHeader_1[index_1] = 'PRICE';
          startIndexPrice_1 = index_1;
        } else {
          priceTypeHeader_1[index_1] = '';
        }
      }

      if (showCompetitivePricing && i === 0) {
        data.children = getDropdownOptionsForSku(data.children, false).flat();
      }

      var headerLength = (data.children ? getMaxLength(data.children, 0) : 0) * multiplicationFactor;
      data.count = headerLength;

      for (var j = index_1 + 1; j < index_1 + headerLength; j++) {
        topHeader_1[j] = '';
        priceTypeHeader_1[j] = '';
      }

      index_1 += headerLength;

      if (data.children) {
        childrenHeaders_1.push.apply(childrenHeaders_1, __spread(data.children));
      }
    });

    if (isTabbedView) {
      if (!ws) {
        ws = XLSX.utils.json_to_sheet([priceTypeHeader_1], {
          skipHeader: true
        });
        XLSX.utils.sheet_add_json(ws, [topHeader_1], {
          skipHeader: true,
          origin: {
            r: rowCount + 1,
            c: 0
          }
        });
      } else {
        XLSX.utils.sheet_add_json(ws, [topHeader_1], {
          skipHeader: true,
          origin: {
            r: rowCount,
            c: 0
          }
        });
      }
    } else {
      if (!ws) {
        ws = XLSX.utils.json_to_sheet([topHeader_1], {
          skipHeader: true
        });
      } else {
        XLSX.utils.sheet_add_json(ws, [topHeader_1], {
          skipHeader: true,
          origin: {
            r: rowCount,
            c: 0
          }
        });
      }
    }

    return createWorksheetObject(childrenHeaders_1, rowCount + 2, ws, selectedData, isRowSelected, showCompetitivePricing, isShipping, isTabbedView);
  }

  return {
    ws: ws,
    headerList: headerList,
    rowCount: rowCount
  };
};

var exportExcelData = function exportExcelData(headerList, row, selectedData, subHeaders, rowData, logger, showCompetitivePricing, isShipping, shippingConfiguration, isTabbedView) {
  var ws = null;

  try {
    var isRowSelected = selectedData.pivotAttributes.Row !== 'None';

    var _a = createWorksheetObject(headerList, row, null, selectedData, isRowSelected, showCompetitivePricing, isShipping, isTabbedView),
        worksheet = _a.ws,
        childrenHeaders = _a.headerList,
        rowCount = _a.rowCount;

    ws = worksheet;
    var startColumnIndex = isRowSelected ? 1 : 0;
    var fileHeaders = subHeaders.map(function (head) {
      return head.value.toString();
    });

    if (isShipping) {
      // Creating shipping and product price keys
      for (var i = 0; i < childrenHeaders.length; i++) {
        var value = childrenHeaders[i].value;
        var productKey = value + "Product Price";
        var shippingKey = value + "Shipping Price";
        fileHeaders.push.apply(fileHeaders, __spread([productKey, shippingKey]));
      }

      subHeaders.push.apply(subHeaders, __spread(childrenHeaders));
      var headers = getFinalHeaders(fileHeaders, selectedData);
      var finalHeaders = headers.finalHeaders,
          priceTypeHeaders = headers.priceTypeHeaders;
      var gridData = getExcelRowData(subHeaders, rowData, isShipping); // Add grid data headers

      XLSX.utils.sheet_add_aoa(ws, [finalHeaders], {
        origin: {
          r: rowCount,
          c: 0
        }
      });

      var mergedArray = __spread(mergeColumnsExcel(headerList, startColumnIndex, isTabbedView ? row + 1 : row, []), mergeFinalHeadersColumn(finalHeaders, startColumnIndex, rowCount));

      if (isTabbedView) {
        var mergerArray = mergeHeadersExcel(headerList, startColumnIndex, row, [], isShipping);
        mergedArray.push.apply(mergedArray, __spread(mergerArray));
      }

      ws['!merges'] = mergedArray; // Add price type headers i.e Product Price, Shipping Price,...

      XLSX.utils.sheet_add_aoa(ws, [priceTypeHeaders], {
        origin: {
          r: rowCount + 1,
          c: 0
        }
      });
      XLSX.utils.sheet_add_json(ws, gridData, {
        header: fileHeaders,
        skipHeader: true,
        origin: {
          r: rowCount + 2,
          c: 0
        }
      });
      ws = addSelectedData(ws, selectedData);
      ws = addShippingConfiguration(ws, shippingConfiguration);
    } else {
      var mergedArray = mergeColumnsExcel(headerList, startColumnIndex, isTabbedView ? row + 1 : row, []);

      if (isTabbedView) {
        var mergerArray = mergeHeadersExcel(headerList, startColumnIndex, row, [], isShipping);
        mergedArray.push.apply(mergedArray, __spread(mergerArray));
      }

      ws['!merges'] = mergedArray;
      subHeaders.push.apply(subHeaders, __spread(childrenHeaders));
      var fileHeaders_1 = subHeaders.map(function (head) {
        return head.value.toString();
      });
      var gridData = getExcelRowData(subHeaders, rowData, isShipping);
      XLSX.utils.sheet_add_json(ws, gridData, {
        header: fileHeaders_1,
        skipHeader: false,
        origin: {
          r: rowCount,
          c: 0
        }
      });
      ws = renameExcelHeaders(ws, rowCount + 1, subHeaders);
      ws = addSelectedData(ws, selectedData);
    }
  } catch (error) {
    logger.logError({
      message: 'Error in downloading pricing grid',
      error: error
    }, 'Export Grid');
    return false;
  }

  downloadExcel(ws, selectedData.sku);
  return true;
};

var getColumnCount = function getColumnCount(headerList, headerName) {
  var count = 0;
  var obj = headerList.find(function (obj) {
    return obj.name === headerName;
  });

  if (obj) {
    count = getColumnLength([obj], 0);
  }

  return count;
};

var getCellRangeWithEndIndex = function getCellRangeWithEndIndex(count, startIndex, row, isShipping) {
  count = isShipping ? count * 2 : count;
  var fromIndex = startIndex;
  var toIndex = fromIndex + count - 1;
  var addressTo = {
    c: toIndex,
    r: row
  };
  var addressFrom = {
    c: fromIndex,
    r: row
  };
  var range = XLSX.utils.encode_cell(addressFrom) + ":" + XLSX.utils.encode_cell(addressTo);
  return {
    range: range,
    toIndex: toIndex
  };
};

var mergeHeadersExcel = function mergeHeadersExcel(headerList, startIndex, row, mergerArray, isShipping) {
  // Merging price header
  var count = getColumnCount(headerList, 'Catalog Price') + getColumnCount(headerList, 'Contracts');

  var _a = getCellRangeWithEndIndex(count, startIndex, row, isShipping),
      priceRange = _a.range,
      toIndex = _a.toIndex;

  startIndex = toIndex + 1;
  mergerArray.push(XLSX.utils.decode_range(priceRange)); // Merging cost header

  count = getColumnCount(headerList, 'Manufacturing Cost') + getColumnCount(headerList, 'Network');
  var costRange = getCellRangeWithEndIndex(count, startIndex, row, isShipping).range;
  mergerArray.push(XLSX.utils.decode_range(costRange));
  return mergerArray;
};

var getFinalHeaders = function getFinalHeaders(fileHeaders, selectedData) {
  var pivotAttributes = selectedData.pivotAttributes;
  var Row = pivotAttributes.Row,
      Column = pivotAttributes.Column;
  var finalHeaders = [];
  var priceTypeHeaders = [];
  var headersCount = fileHeaders.length; // If dual pivot mode

  if (Column !== 'None') {
    for (var i = 0; i < headersCount; i++) {
      if (fileHeaders[i].toLowerCase() !== Row.toLowerCase()) {
        var values = fileHeaders[i].split('|');
        values = values.filter(Boolean);
        var priceType = values.pop();
        var headerName = values.pop();
        priceType === 'Product Price' ? finalHeaders.push(headerName.toUpperCase()) : finalHeaders.push('');
        priceTypeHeaders.push(priceType);
      } else {
        finalHeaders.push(fileHeaders[i].toUpperCase());
        priceTypeHeaders.push('');
      }
    }
  } else {
    for (var i = 0; i < headersCount; i++) {
      if (fileHeaders[i].toLowerCase() !== Row.toLowerCase()) {
        var values = fileHeaders[i].split('|');
        values = values.filter(Boolean);
        var priceType = values.pop();
        var headerName = values.pop();
        priceType === 'Product Price' ? finalHeaders.push(headerName.toUpperCase()) : finalHeaders.push('');
        priceTypeHeaders.push(priceType);
      } else {
        finalHeaders.push(fileHeaders[i].toUpperCase());
        priceTypeHeaders.push('');
      }
    }
  }

  return {
    finalHeaders: finalHeaders,
    priceTypeHeaders: priceTypeHeaders
  };
};

var mergeFinalHeadersColumn = function mergeFinalHeadersColumn(finalHeaders, startColumnIndex, rowCount) {
  var mergerArray = [];
  var headersCount = finalHeaders.length;
  var columnIndex = startColumnIndex;

  for (var i = 1; i < headersCount; i++) {
    var s = {
      c: columnIndex,
      r: rowCount
    };
    var e = {
      c: columnIndex + 1,
      r: rowCount
    };
    mergerArray.push({
      s: s,
      e: e
    });
    columnIndex = columnIndex + 2;
  }

  return mergerArray;
};

var isShippingConfigurationSet = function isShippingConfigurationSet(shippingConfig) {
  if (!shippingConfig || !shippingConfig.fulfillmentLocation) {
    return false;
  }

  var shippingAttributes = Object.keys(shippingConfig);

  for (var i = 0; i < shippingAttributes.length; i++) {
    if (!shippingConfig[shippingAttributes[i]] || shippingConfig[shippingAttributes[i]] == '') {
      return false;
    }
  }

  return true;
};

var getSelectedValues = function getSelectedValues(skuData, displayedAttributes) {
  var values = {};
  var resolvedAttributes = get(skuData, 'resolvedAttributes[0].values[0].attributes', []);
  displayedAttributes.forEach(function (attribute) {
    var object = find(resolvedAttributes, {
      attributeKey: attribute
    });

    if (object) {
      values[attribute] = object.attributeValue;
    } else {
      values[attribute] = '';
    }
  });
  return values;
};